import Location from "../game/Location";
import * as LootTableData from "./LootTableData";

export const locations = [
  new Location({
    id: 1,
    name: "Floor 1 Area 1",
    enemies: ["greenSlime"],
    drops: ['bronzeHelmet','bronzeGauntlets','bronzeGreeves'],
    lootTable: LootTableData.lootTables["bronzeWeapon"],
  }),
  new Location({
    id: 2,
    name: "Floor 1 Area 2",
    enemies: ["redSlime"],
    drops: ['bronzeDagger','bronzeAxe','bronzeShield'],
    lootTable: LootTableData.lootTables["bronzeArmor"],
  }),
  new Location({
    id: 3,
    name: "Floor 1 Area 3",
    enemies: ["blueSlime"],
    drops: ['bronzeHelmet','bronzeGauntlets','bronzeGreeves'],
    lootTable: LootTableData.lootTables["bronzeSet"],
  }),
  new Location({
    id: 4,
    name: "Floor 1 Area 4",
    enemies: ["yellowSlime"],
    drops: ['bronzeGreatsword', 'bronzeChestplate'],
    lootTable: LootTableData.lootTables["bronzeSet"],
  }),
  new Location({
    id: 5,
    name: "Floor 1 Area 5 (Boss)",
    enemies: ["kingSlime"],
    drops: ['ironSword'],
    lootTable: LootTableData.lootTables["ironSet"],
  }),
];